var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',_vm._g(_vm._b({},'el-dialog',_vm.$attrs,false),_vm.inputListeners),[_c('template',{slot:"title"},[_vm._t("header")],2),_vm._t("default"),_c('template',{slot:"footer"},[_vm._t("footer")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }